// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkbox-Eq\\+D- {\n  vertical-align: top;\n  position: relative;\n  display: block;\n}\n.checkbox-Eq\\+D- input[type=\"checkbox\"] {\n  position: absolute;\n  margin-left: -20px;\n  opacity: 0;\n}\ninput[type=\"checkbox\"]:focus + .label-0GhpL:before {\n  border-color: #008859;\n}\ninput[type=\"checkbox\"]:focus + .label-0GhpL:hover:after {\n  opacity: 0.4;\n  -webkit-transform: translate(-50%, -50%) scale(1);\n  -ms-transform: translate(-50%, -50%) scale(1);\n  transform: translate(-50%, -50%) scale(1);\n}\n.label-0GhpL {\n  margin: 0;\n  display: inline-block;\n  padding-left: 30px;\n  padding-top: 4px;\n  min-height: 20px;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  word-wrap: break-word;\n  word-break: break-word;\n  font-weight: normal;\n}\n.label-0GhpL:before {\n  content: \"\\f00c\";\n  position: absolute;\n  color: #f4f4f4;\n  background-color: #fff;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #cfcfcf;\n  border-radius: 0.4rem;\n  left: 2px;\n  top: 2px;\n  font-family: \"FontAwesome\";\n  font-size: 11px;\n  text-align: center;\n  line-height: 16px;\n  z-index: 1;\n}\n.label-0GhpL:after {\n  content: \"\";\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  left: 11px;\n  top: 11px;\n  -webkit-transform: translate(-50%, -50%) scale(0.4);\n  -ms-transform: translate(-50%, -50%) scale(0.4);\n  transform: translate(-50%, -50%) scale(0.4);\n  background-color: #cfcfcf;\n  border-radius: 50%;\n  opacity: 0;\n  transition: all 0.2s;\n}\n.label-0GhpL.disabled:hover:before {\n  border-color: #cfcfcf;\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n.label-0GhpL.disabled:after {\n  display: none;\n}\n.label-0GhpL.checked:before {\n  background-color: #008859;\n  border: 2px solid #008859;\n  color: #fff;\n}\n.label-0GhpL.checked:after {\n  -webkit-transform: translate(-50%, -50%) scale(0.4);\n  -ms-transform: translate(-50%, -50%) scale(0.4);\n  transform: translate(-50%, -50%) scale(0.4);\n  background-color: #008859;\n}\n.label-0GhpL.checked.disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n.label-0GhpL.checked.disabled:hover:before {\n  background-color: #008859;\n  border-color: #008859;\n}\n.label-0GhpL.checked.disabled:after {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/form-controls/checkboxes/checkbox/checkbox.less"],"names":[],"mappings":"AAKA;EAEI,mBAAA;EACA,kBAAA;EACA,cAAA;AA+GJ;AAnHA;EAOM,kBAAA;EACA,kBAAA;EACA,UAAA;AA+GN;AAxGI;EACE,qBAAA;AA0GN;AAvGI;EACE,YAAA;EACA,iDAAA;EACA,6CAAA;EACA,yCAAA;AAyGN;AAjIA;EA6BI,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAuGJ;AArGI;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;AAuGN;AApGI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mDAAA;EACA,+CAAA;EACA,2CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAsGN;AAhGU;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;AAkGZ;AA9FQ;EACE,aAAA;AAgGV;AA3FQ;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AA6FV;AA1FQ;EACE,mDAAA;EACA,+CAAA;EACA,2CAAA;EACA,yBAAA;AA4FV;AAzFQ;EACE,mBAAA;EACA,aAAA;AA2FV;AAxFY;EACE,yBAAA;EACA,qBAAA;AA0Fd;AAtFU;EACE,aAAA;AAwFZ","sourcesContent":["@import \"@cirrus/legacy/app-components/app/styles/font-size-variables.less\";\n@import \"variables\";\n@import \"@cirrus/legacy/app-components/app/styles/mixins.less\";\n@import \"@cirrus/legacy/app-components/app/styles/colors/colors-default.less\";\n\n:local {\n  .checkbox {\n    vertical-align: top;\n    position: relative;\n    display: block;\n\n    input[type=\"checkbox\"] {\n      position: absolute;\n      margin-left: -20px;\n      opacity: 0;\n    }\n  }\n\n  //TODO: make it material like checkbox\n\n  input[type=\"checkbox\"]:focus + .label {\n    &:before {\n      border-color: @clr-green-300;\n    }\n\n    &:hover:after {\n      opacity: 0.4;\n      -webkit-transform: translate(-50%, -50%) scale(1);\n      -ms-transform: translate(-50%, -50%) scale(1);\n      transform: translate(-50%, -50%) scale(1);\n    }\n  }\n\n  .label {\n    margin: 0;\n    display: inline-block;\n    padding-left: 30px;\n    padding-top: 4px;\n    min-height: 20px;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    word-wrap: break-word;\n    word-break: break-word;\n    font-weight: normal;\n\n    &:before {\n      content: \"\\f00c\";\n      position: absolute;\n      color: @clr-gray-202;\n      background-color: @clr-white;\n      width: 18px;\n      height: 18px;\n      border: 2px solid @clr-gray-240;\n      border-radius: 0.4rem;\n      left: 2px;\n      top: 2px;\n      font-family: \"FontAwesome\";\n      font-size: 11px;\n      text-align: center;\n      line-height: @checkbox-label-line-height;\n      z-index: 1;\n    }\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      width: 40px;\n      height: 40px;\n      left: 11px;\n      top: 11px;\n      -webkit-transform: translate(-50%, -50%) scale(0.4);\n      -ms-transform: translate(-50%, -50%) scale(0.4);\n      transform: translate(-50%, -50%) scale(0.4);\n      background-color: @clr-gray-240;\n      border-radius: 50%;\n      opacity: 0;\n      transition: all 0.2s;\n    }\n\n    &:global {\n      &.disabled {\n        &:hover {\n          &:before {\n            border-color: @clr-gray-240;\n            cursor: not-allowed;\n            opacity: 0.65;\n          }\n        }\n\n        &:after {\n          display: none;\n        }\n      }\n\n      &.checked {\n        &:before {\n          background-color: @clr-green-300;\n          border: 2px solid @clr-green-300;\n          color: @clr-white;\n        }\n\n        &:after {\n          -webkit-transform: translate(-50%, -50%) scale(0.4);\n          -ms-transform: translate(-50%, -50%) scale(0.4);\n          transform: translate(-50%, -50%) scale(0.4);\n          background-color: @clr-green-300;\n        }\n\n        &.disabled {\n          cursor: not-allowed;\n          opacity: 0.65;\n\n          &:hover {\n            &:before {\n              background-color: @clr-green-300;\n              border-color: @clr-green-300;\n            }\n          }\n\n          &:after {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitleFontSize": "22px",
	"pageTitleLineHeight": "55px",
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"checkbox": "checkbox-Eq+D-",
	"label": "label-0GhpL"
};
export default ___CSS_LOADER_EXPORT___;
